import { genUuidV4 } from "./uuidv4";

export const flowTypes = {
  F_ERROR: "F_ERROR",
  F_INFO: "F_INFO",
  F_OK: "F_OK",
  F_DEFAULT: "F_DEFAULT"
};

export const FlowItem = ({ type = flowTypes.F_DEFAULT, message }) => ({
  uuid: genUuidV4(),
  type,
  message
});
